import { MessageState } from './state'

export const getters = {
  getShow: (state: MessageState) => state.show,
  getTitle: (state: MessageState) => state.title,
  getTypeOfMessage: (state: MessageState) => state.typeOfMessage,
  getMessage: (state: MessageState) => state.msg,
}
